import { render, staticRenderFns } from "./CoursePack.vue?vue&type=template&id=cf6d3d16&scoped=true"
import script from "./CoursePack.vue?vue&type=script&lang=js"
export * from "./CoursePack.vue?vue&type=script&lang=js"
import style0 from "./CoursePack.vue?vue&type=style&index=0&id=cf6d3d16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6d3d16",
  null
  
)

export default component.exports